var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 4.75843C14.925 4.43343 14.4 4.43343 14.075 4.75843L10 8.8251L5.92501 4.7501C5.60001 4.4251 5.07501 4.4251 4.75001 4.7501C4.42501 5.0751 4.42501 5.6001 4.75001 5.9251L8.82501 10.0001L4.75001 14.0751C4.42501 14.4001 4.42501 14.9251 4.75001 15.2501C5.07501 15.5751 5.60001 15.5751 5.92501 15.2501L10 11.1751L14.075 15.2501C14.4 15.5751 14.925 15.5751 15.25 15.2501C15.575 14.9251 15.575 14.4001 15.25 14.0751L11.175 10.0001L15.25 5.9251C15.5667 5.60843 15.5667 5.0751 15.25 4.75843Z",
    fill: "#1F4C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3b30bc073f728fa6d21fb298d4ec8751.svg";
export { ForwardRef as ReactComponent };